import { TranslatedCopy } from '../../intl/TranslatedCopy';

const searchKeyOptions = [
  {
    label: new TranslatedCopy({ id: 'returnStatus.authNumber' }).toString(),
    value: 'returnAuthorizationIds'
  },
  {
    label: new TranslatedCopy({ id: 'returnStatus.returnReference' }).toString(),
    value: 'returnReferences'
  },
  {
    label: new TranslatedCopy({ id: 'global.submittedBy' }).toString(),
    value: 'submittedBys'
  }
];

const dateRangeOptions = [
  {
    label: new TranslatedCopy({ id: 'orderstatus.date.select.3' }).toString(),
    value: '3 months'
  },
  {
    label: new TranslatedCopy({ id: 'orderstatus.date.select.6' }).toString(),
    value: '6 months'
  },
  {
    label: new TranslatedCopy({ id: 'orderstatus.date.select.12' }).toString(),
    value: '12 months'
  },
  {
    label: new TranslatedCopy({ id: 'orderstatus.date.select.18' }).toString(),
    value: '18 months'
  },
  {
    label: new TranslatedCopy({ id: 'orderstatus.date.select.24' }).toString(),
    value: '24 months'
  },
  {
    label: new TranslatedCopy({ id: 'orderstatus.date.select.custom' }).toString(),
    value: 'custom'
  }
];

const sortOptions = [
  { name: 'returnStatus.authNumber', value: 'returnAuthorizationId' },
  {
    name: 'returnStatus.returnReference',
    value: 'referenceId'
  },
  {
    name: 'returnStatus.creditType',
    value: 'creditType'
  },
  {
    name: 'orderreturns.returnAmount',
    value: 'creditedAmount'
  },
  {
    name: 'global.submittedBy',
    value: 'createdBy'
  },
  {
    name: 'orderstatus.orderSubmittedDate',
    value: 'createTimestamp'
  },
  {
    name: 'returnStatus.dateExpires',
    value: 'expirationDate'
  },
  {
    name: 'returnStatus.title',
    value: 'status'
  }
];

export { searchKeyOptions, dateRangeOptions, sortOptions };
